import { useQuery } from "@tanstack/react-query";

import { getCountryByCode } from "helpers/countries";
import RegionService from "services/Regions";

const handleFetchRegionsAndCountries = async () => {
  const rawRegions = await RegionService.getRegions();
  const regions = rawRegions.map(({ id, name, countries = [] }) => ({
    id,
    name,
    extraData: { countries },
  }));

  const allCountries = rawRegions.reduce((countries, region) => {
    countries.push(...region.countries);
    return countries;
  }, []);
  allCountries.sort();
  const countries = Array.from(new Set(allCountries)).map(country => ({
    id: country,
    name: getCountryByCode(country).text,
    value: country,
    key: country,
  }));
  return { regions, countries };
};

export function useRegionCountryForFilters() {
  const { data: regionsAndCountries, isSuccess: isRegionsAndCountriesFetched } =
    useQuery({
      queryKey: ["regions"],
      queryFn: handleFetchRegionsAndCountries,
    });

  return {
    regionsAndCountries,
    isRegionsAndCountriesFetched,
  };
}
